'use client';

import * as React from 'react';
import JoinClient from './JoinClient';

export default function Page() {
  return (
    <React.Suspense
      fallback={
        <main className="min-h-screen bg-slate-950 text-slate-50 flex items-center justify-center px-4 py-8">
          <div className="rounded-3xl border border-slate-800 bg-slate-900/90 px-6 py-4 text-sm text-slate-200 shadow-2xl">
            Loading join screen…
          </div>
        </main>
      }
    >
      <JoinClient />
    </React.Suspense>
  );
}
